export const EMPTY_ARTICLE_TITLE = 'Untitled Article';
export const DEFAULT_ARTICLE_DESCRIPTION = 'Description';
